import PropTypes from 'prop-types'
import React from 'react'

const DealerClosedCell = ({ row }) => {
  const isClosed = !!row.dealerClosed

  return (
    <span className="inline-flex items-center gap-2">
      <div
        className={`h-[13px] w-[13px] shrink-0 rounded-full border-[3px] ${
          isClosed ? 'border-charcoal-400 bg-charcoal-400' : 'border-green-800'
        }`}
      />
      {isClosed && <span className="text-charcoal-900 text-sm font-medium">Dealer Closed</span>}
      <span className="sr-only">{isClosed ? 'Dealer closed' : 'Not dealer closed'}</span>
    </span>
  )
}

DealerClosedCell.propTypes = {
  row: PropTypes.object.isRequired,
}

export default DealerClosedCell
